import React from 'react';
import { Glyphicon, Button } from 'react-bootstrap'
import API from 'fw/system/API'

class DownloadFileLink extends React.Component {
    handleClick = () => {
        if (this.props.useEncryption) {
            new API().downloadEncrypted(
                {
                    storageToken: this.props.storageToken,
                    fileName: this.props.fileName,
                    useEncryption: this.props.useEncryption
                });
                return false;
        }
        else {
            new API().download(
                {
                    storageToken: this.props.storageToken,
                    fileName: this.props.fileName,
                    useEncryption: this.props.useEncryption
                });
        }
    }

    render() {
        if (this.props.storageToken == null || this.props.storageToken === "")
            return null;

        const buttonName = this.props.buttonName == null ? "Download" : this.props.buttonName;
        const buttonStyle = this.props.buttonStyle == null ? "default" : this.props.buttonStyle;
        const icon = this.props.icon == null ? "download" : this.props.icon;

        return (
            <Button 
                title={this.props.title} 
                bsSize="xsmall" 
                bsStyle={buttonStyle} 
                onClick={this.handleClick}>
                    <Glyphicon glyph={icon} />&nbsp;
                    {buttonName.length > this.props.wrapFileNameLength 
                        ? buttonName.slice(0, (this.props.wrapFileNameLength - 4)) + "..." + buttonName.slice(-4) 
                        : buttonName}
            </Button>
        )
    }

}

export default DownloadFileLink

DownloadFileLink.defaultProps = {
    wrapFileNameLength: 50,
    useEncryption: false,
    title: ''
};


// WEBPACK FOOTER //
// ./src/fw/components/downloadFileLink/DownloadFileLink.js